export default __webpack_public_path__ + "static/media/twitter.ff19098c.svg";